<div class="main">
  <div class="header">
    <h2>Reset Password</h2>
    <p>Please enter your current password and new password to reset your password</p>
  </div>
  <div class="reset-form">
    <form [formGroup]="passwordForm" (ngSubmit)="onSubmit()">
      <mat-form-field appearance="outline">
        <mat-label>Current Password</mat-label>
        <input matInput [type]="showCurrentPassword ? 'text' : 'password'" formControlName="currentPassword" required>
        <button mat-icon-button matSuffix (click)="toggleShowPassword('current')">
          <mat-icon>{{ showCurrentPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
        </button>
        <mat-error *ngIf="passwordForm.get('currentPassword')?.hasError('required')">
          Invalid Password, please enter your password correctly
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>New Password</mat-label>
        <input matInput [type]="showNewPassword ? 'text' : 'password'" formControlName="newPassword" required>
        <button mat-icon-button matSuffix (click)="toggleShowPassword('new')">
          <mat-icon>{{ showNewPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
        </button>
        <mat-error *ngIf="passwordForm.get('newPassword')?.hasError('required')">
          New Password is required
        </mat-error>
        <mat-error *ngIf="passwordForm.get('newPassword')?.hasError('minlength')">
          New Password must be at least 8 characters long
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Confirm New Password</mat-label>
        <input matInput [type]="showConfirmPassword ? 'text' : 'password'" formControlName="confirmNewPassword" required>
        <button mat-icon-button matSuffix (click)="toggleShowPassword('confirm')">
          <mat-icon>{{ showConfirmPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
        </button>
        <mat-error *ngIf="passwordForm.get('confirmNewPassword')?.hasError('required')">
          Confirming New Password is required
        </mat-error>
        <mat-error *ngIf="passwordForm.hasError('passwordMismatch')">
          Passwords do not match
        </mat-error>
      </mat-form-field>

      <button mat-raised-button color="primary" type="submit" [disabled]="passwordForm.invalid">
        Change Password
      </button>
    </form>
  </div>
</div>
